// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "td.dx-treelist-action {\n  width: 100%;\n}", "",{"version":3,"sources":["webpack://src/components/utility-component/group-sort-widget/group-sort-widget-style.scss"],"names":[],"mappings":"AACA;EACI,WAAA;AAAJ","sourcesContent":["\ntd.dx-treelist-action {\n    width: 100%;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
